import Model, { ID, JsonArray, MODEL_LEVEL } from 'src/models/model'

export default class CustomerioSegment extends Model {
  static name = 'CustomerioSegment'

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Marketing]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true,
        output: true
      },
      description: {
        type: String,
        required: false,
        output: true
      },
      tags: {
        type: [String],
        required: false,
        output: true
      },
      memberCount: {
        type: Number,
        required: false,
        output: true
      },
      conditions: {
        type: JsonArray,
        required: false,
        output: true
      }
    }
  }
}
